// กติกา temperature / top_p ตามตระกูลโมเดล ใช้ในหน้า Model Creator (ModelManagement.vue)
// ให้รู้ล่วงหน้าว่าค่าที่ตั้งใช้ได้ไหม โดยไม่ต้องรอยิงทดสอบ (Test Model) ซึ่งช้า
//
// เทียบ pattern กับชื่อ deployment (ModelName) และ Display Name ของ ModelData แบบไม่สนตัวพิมพ์
// ถ้าตั้งชื่อ deployment เองจนไม่ตรง pattern จะนับเป็นโมเดลที่ไม่รู้จัก -> แค่เตือนให้กด Test Model
// เก็บเป็นข้อมูลล้วน (regex + ค่า) เพื่อให้ backend ยกไปใช้ชุดเดียวกันได้ถ้าจะทำ runtime fallback

// ค่าเริ่มต้นตอนผู้ใช้เลือก model: ตระกูล GPT-4 ใช้ 0 ส่วนตัวอื่นทั้งหมดใช้ 1
// รุ่นใหม่ (GPT-5 ขึ้นไป / reasoning model) ส่วนใหญ่รับได้แค่ 1 มี model ใหม่ออกมาก็ไม่ต้องแก้โค้ด
export const ZERO_DEFAULT_SAMPLING_PATTERNS = [/^gpt-4/i];
export const ZERO_DEFAULT_SAMPLING = { temperature: 0, topP: 0 };
export const DEFAULT_SAMPLING = { temperature: 1, topP: 1 };

// รับได้แค่ค่า default = 1 ถ้าส่งค่าอื่น provider ตอบ 400 unsupported_value
// ("Only the default (1) value is supported") แล้วผู้ใช้เห็น 'ไม่สามารถตอบคำถามนี้ได้ [2]'
// ยืนยันด้วย Test Model จริง (2026-09-30): Azure gpt-5.2 + reasoning low ส่ง temperature 0 ไม่ผ่าน, 1 ผ่าน
export const FIXED_SAMPLING_MODEL_RULES = [
  { family: 'OpenAI o-series', pattern: /^o\d+(?:[-.]|$)/i, temperature: 1, topP: 1 },
  // GPT-5 ขึ้นไป (5-9, 10+) — gpt-6 ออกมาก็ถูกนับเองไม่ต้องแก้โค้ด ถ้ารุ่นไหนรับค่าอื่นได้ กด Test Model ผ่านจะปลดล็อกให้
  // gpt-35-* คือ GPT-3.5 บน Azure (ไม่ใช่เวอร์ชัน 35) จึงกันไว้
  // gpt-*-chat เป็นรุ่นไม่ใช้ reasoning ยังไม่ยืนยันว่ารับค่าอื่นได้ จึงไม่บังคับ (แค่ตั้ง default 1)
  { family: 'GPT-5+', pattern: /^gpt-(?!35(?:[-.]|$))(?:[5-9]|[1-9]\d+)(?:[-.]|$)/i, exclude: /-chat/i, temperature: 1, topP: 1 },
];

// รู้แน่ว่ารับค่าได้ทั้งช่วง 0-1 ไม่ต้องเตือน
export const FREE_SAMPLING_MODEL_PATTERNS = [/^gpt-4/i, /^gpt-35/i, /^gpt-3\.5/i, /^claude/i, /^gemini/i];
